// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2bLnr","addWidgetButton":"Header_addWidgetButton__OavoQ","dashboardTabs":"Header_dashboardTabs__1loN4","active":"Header_active__tsJOq"};